import React from 'react';
import { Slider } from '@mui/material';
import { StudioClipProps } from '../../StudioClip';
import { CompleteProps } from '.';
import useAudioPlayer from '../../../../lib/useAudioPlayer';

export interface SliderWrapperProps {
  sliderValue: number;
  isSeeking: boolean;
  clip: StudioClipProps['clip'];
  classes: CompleteProps['studioClipCompleteClasses']['classes'];
  playerState: ReturnType<typeof useAudioPlayer>[0]['state'];
  disabled?: boolean;
  onChange: (event: Event, value: number | number[]) => void;
  onChangeCommitted: (
    event: React.SyntheticEvent | Event,
    value: number | number[]
  ) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLSpanElement>) => void;
  onMouseDown: () => void;
}

const SliderWrapper = ({
  clip,
  classes,
  disabled,
  playerState,
  sliderValue,
  isSeeking,
  onChange,
  onChangeCommitted,
  onKeyDown,
  onMouseDown,
}: SliderWrapperProps) => {
  return (
    <div className={classes.sliderContainer}>
      <Slider
        classes={
          isSeeking || playerState !== 'PLAYING'
            ? {
                root: classes.sliderRoot,
                thumb: classes.sliderThumb,
              }
            : {
                root: classes.sliderRoot,
                thumb: `${classes.sliderThumb} ${classes.sliderThumbTransition}`,
                track: classes.sliderTrackTransition,
              }
        }
        disabled={
          disabled ||
          !!clip.failedWithError ||
          playerState === 'ERROR' ||
          playerState === 'LOADING'
        }
        min={0}
        max={1}
        step={0.001}
        value={sliderValue}
        onChange={onChange}
        onChangeCommitted={onChangeCommitted}
        onMouseDown={onMouseDown}
        onKeyDown={onKeyDown}
        aria-label={`clip-${clip.name}-slider`}
      />
    </div>
  );
};

export default SliderWrapper;
